
import { CreateElement } from 'vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Picture extends Vue {
    /**
     *
     */
    @Prop()
    public readonly src!: string;
    /**
     *
     */
    @Prop({ default: null })
    public readonly alt!: string;
    /**
     *
     */
    @Prop({ default: 'fade' })
    public readonly transition!: string;
    /**
     *
     */
    @Prop({ default: 'img' })
    public readonly tag!: string;
    /**
     *
     */
    public image: HTMLImageElement | null = null;
    /**
     *
     */
    public loaded: boolean = false;
    /**
     *
     */
    public error: boolean = false;

    onLoadHandler() {
        this.loaded = true;
        this.error = false;
        this.$emit('loaded');
    }

    onErrorHandler() {
        this.loaded = true;
        this.error = true;
        this.$emit('error');
    }

    loadImage() {
        this.image = new Image();
        this.image.addEventListener('load', this.onLoadHandler);
        this.image.addEventListener('error', this.onErrorHandler);
        this.image.src = this.src;
    }

    beforeDestroy() {
        this.image?.removeEventListener('load', this.onLoadHandler);
        this.image?.removeEventListener('error', this.onErrorHandler);
    }

    mounted() {
        this.src && this.loadImage();
    }

    @Watch('src')
    watchSrc() {
        this.loadImage();
    }

    render(h: CreateElement) {
        const { src, alt, loaded, error, $slots } = this;

        if (src) {
            if (loaded) {
                return h(
                    'transition',
                    {
                        props: {
                            name: this.transition,
                        },
                    },
                    this.tag === 'img'
                        ? [
                              h('img', {
                                  attrs: {
                                      src,
                                      alt: alt || '',
                                  },
                              }),
                          ]
                        : [
                              h(this.tag, {
                                  attrs: {
                                      style: {
                                          backgroundImage: `url(${src})`,
                                      },
                                  },
                              }),
                          ]
                );
            } else if (error) {
                return $slots.error;
            } else {
                return $slots.loading;
            }
        } else {
            return $slots.empty;
        }
    }
}
